import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect } from 'react';
import {Button} from 'react-bootstrap'
import BasicExample from './components/Cards';
import MyNavbar from './components/MyNavbar';
import './App.css';
import MyCarousel from './components/MyCarousel';
import MyBasicRouter from './components/MyBasicRouter'
import MyWhatsAppButton from './components/MyWhatsAppButton';
import AOS from 'aos';
import 'aos/dist/aos.css'; // AOS styles
import MyFooter from './components/MyFooter';
import SlickSlider from './components/SlickSlider';
import AntDesign from './components/AntDesign';
import { LanguageProvider } from './context/LanguageContext';
import LanguageSwitcher from './components/LanguageSwitcher';
function App() {
  useEffect(() => {
    AOS.init({
      duration: 800, // animation duration
      easing: 'ease-in-out', // animation timing function
      once: false, // whether animation should happen only once
    });
  }, []);
  return (
    <LanguageProvider>
    <div className="">
      <MyNavbar/>
      
     <MyBasicRouter/>
     <MyWhatsAppButton/>
   <LanguageSwitcher/>  
     <MyFooter/>
    
     </div>
     </LanguageProvider>
  );
}

export default App;
